// ... existing code ...
export
const partition = <T>(es: Array<T>, fn: (a: T) => boolean): [Array<T>, Array<T>] =>
    es.reduce<[Array<T>, Array<T>]>(([p, f], e) => (fn(e) ? [[...p, e], f] : [p, [...f, e]]), [[], []]);
